import {
	actionTypes,
	ActionTypes,
	QAChecksFetchFilesAction,
	QAChecksFetchFilesErrorAction,
	QAChecksSetCurrentAction,
	QAChecksSetFilterParamsAction,
	QAChecksFetchListSuccessAction,
	QAChecksFetchFilesSuccessAction,
	QAChecksFilterParamsResetAction,
	QAChecksSetCurrentSuccessAction,
} from './actions'

import { QACheck } from 'src/lib/interfaces/QACheck.interface'
import { BaseReportFilterParameters } from 'src/lib/interfaces/BaseReportFilterParameters.interface'

const moment = require('moment')

const initialFilterParams: BaseReportFilterParameters = {
	fromDate: moment().format('YYYY-MM-DD'),
}

export interface QAChecksState {
	readonly fetchFilesError?: any
	readonly isFetchingFiles: boolean
	readonly isFetchingQAChecks: boolean
	readonly filterParams: BaseReportFilterParameters
	
	readonly qaChecks?: QACheck[]
	readonly currentQACheck?: QACheck
}

export const initialState: QAChecksState = {
	qaChecks: undefined,
	isFetchingFiles: false,
	isFetchingQAChecks: false,
	currentQACheck: undefined,
	fetchFilesError: undefined,
	filterParams: initialFilterParams,
}

export function reducer(
	state: QAChecksState = initialState,
	action: ActionTypes,
): QAChecksState {
	switch (action.type) {
		case actionTypes.QA_CHECKS_FETCH_LIST:
			return {
				...state,
				isFetchingQAChecks: true,
			}

		case actionTypes.QA_CHECKS_FETCH_LIST_FAILED:
			return {
				...state,
				isFetchingQAChecks: false,
			}

		case actionTypes.QA_CHECKS_FETCH_LIST_SUCCESS:
			return {
				...state,
				isFetchingQAChecks: false,
				qaChecks: (action as QAChecksFetchListSuccessAction).payload.qaChecks,
			}

		case actionTypes.QA_CHECKS_FILTER_PARAMS_RESET: {
			const resetAction = action as QAChecksFilterParamsResetAction

			const filterParams = resetAction.payload.filterParams
			return {
				...state,
				filterParams: {
					...initialFilterParams,
					...(filterParams || {}),
				},
			}
		}
		case actionTypes.QA_CHECKS_SET_FILTER_PARAMS: {
			const filterParams = {
				...state.filterParams,
				...(action as QAChecksSetFilterParamsAction).payload.filterParams,
			}

			return {
				...state,
				filterParams,
			}
		}
		
		case actionTypes.QA_CHECKS_SET_CURRENT:
			return {
				...state,
				currentQACheck: (action as QAChecksSetCurrentAction).payload.qaCheck
			}
		case actionTypes.QA_CHECKS_SET_CURRENT_SUCCESS:
			return {
				...state,
				currentQACheck: (action as QAChecksSetCurrentSuccessAction).payload.qaCheck
			}

		case actionTypes.QA_CHECKS_FETCH_FILES:
      return {
        ...state,
        isFetchingFiles: true,
        fetchFilesError: undefined
      }

    case actionTypes.QA_CHECKS_FETCH_FILES_FAILED: {
      const qaCheckFilesErrorAction = action as QAChecksFetchFilesErrorAction

      return {
        ...state,
        isFetchingFiles: false,
        fetchFilesError: qaCheckFilesErrorAction.payload.errorMessage
      }
    }

    case actionTypes.QA_CHECKS_FETCH_FILES_SUCCESS: {
      const qaCheckFilesAction = action as QAChecksFetchFilesSuccessAction

      const files = qaCheckFilesAction.payload.files
      const qaCheckId = qaCheckFilesAction.payload.qaCheckId

      let currentQACheck = state.currentQACheck
      if (currentQACheck && currentQACheck.id === qaCheckId) {
        currentQACheck = { ...state.currentQACheck } as QACheck
        currentQACheck.files = files
			}
			
      return {
        ...state,
        currentQACheck,
        isFetchingFiles: false,
        fetchFilesError: undefined
      }
    }

		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/store/qaChecks/reducer.ts